import http from '@/plugins/api'
import { startLoading } from '@/plugins/loading'
import * as types from './types'

export default {
  setSearchTerm({ commit }, text) {
    commit(types.SET_SEARCH_TERM, text)
  },
  setPageSize({ commit }, pageSize) {
    commit(types.SET_PAGE_SIZE, pageSize)
  },
  setSortDir({ commit }, sortDir) {
    commit(types.SET_SORT_DIR, sortDir)
  },
  setOrderBy({ commit }, orderBy) {
    commit(types.SET_ORDER_BY, orderBy)
  },
  setFilterBy({ commit }, filterBy) {
    commit(types.SET_FILTER_BY, filterBy)
  },
  setFilterOptions({ commit }, data) {
    commit(types.SET_FILTER_OPTIONS, data)
  },
  initLocations({ commit }) {
    commit(types.SET_LOCATIONS_FOUND, null)
  },
  updatePreference({ commit }, data) {
    commit(types.UPDATE_PREFERENCE, data)
  },
  pushLocation({ commit }, data) {
    commit(types.PUSH_LOCATION, data)
  },
  popLocation({ commit }) {
    commit(types.POP_LOCATION)
  },
  pushInsurance({ commit }, data) {
    commit(types.PUSH_INSURANCE, data)
  },
  popInsurance({ commit }, id) {
    commit(types.POP_INSURANCE, id)
  },
  setInsuranceData({ commit }, data) {
    commit(types.SET_INSURANCE_DATA, data)
  },
  resetPreferences({ commit }) {
    commit(types.RESET_PREFERENCES)
  },
  setPreference({ commit }, data) {
    commit(types.SET_PREFERENCE, data)
  },
  setCurrentLocation({ commit }, data) {
    commit(types.SET_CURRENT_LOCATION, data)
  },
  pushNetwork({ commit }, data) {
    commit(types.PUSH_OUTNETWORK, data)
  },
  popNetwork({ commit }, id) {
    commit(types.POP_OUTNETWORK, id)
  },
  setLocationFilter({ commit }, data) {
    commit(types.SET_LOCATION_FILTER, data)
  },
  async searchFirms({ commit, dispatch }, options) {
    const r = await startLoading(dispatch, 'searchFirms', () => http.get(`firm/searchFirms?search=${options.search}&type=${options.type}`))
    return r.data
  },
  async getOutNetwork({ commit, dispatch }, firm) {
    const r = await startLoading(dispatch, 'getNetworkTree', () => http.get(`firm/firmFirms?firm=${firm}`))
    commit(types.SET_OUTNETWORK, r.data)
    return r.data
  },
  async saveOutNetwork({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'saveOutNetwork', () => http.post('firm/saveFirmFirms', data))
    return r.data
  },
  async getNetworkTree({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'getNetworkTree', () =>
      http.get(`firm/locationTree?id=${data.id}&firm=${data.firm}&showInactive=${data.showInactive}`)
    )
    commit(types.SET_NETWORK_TREE, r.data)
    return r.data
  },
  async getLocationTree({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'getLocationTree', () => http.get(`firm/locationTree?id=${data.id}&firm=${data.firm}`))
    commit(types.SET_LOCATION_TREE, r.data)
    return r.data
  },
  async getLocations({ commit, dispatch }, searchOptions) {
    const r = await startLoading(dispatch, 'getLocations', () =>
      http.get('firm/getFirms', {
        params: searchOptions
      })
    )
    commit(types.SET_LOCATIONS, r.data)
    return r.data
  },
  async getChildLocations({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'getChildLocations', () => http.get(`firm/getChildFirms?firm=${data.firm}&gettype=${data.gettype}`))
    commit(types.SET_LOCATIONS, r.data)
    return r.data
  },
  async getLocation({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getLocation', () => http.get(`firm/firm?firm=${id}`))
    commit(types.SET_LOCATION, r.data)
    return r.data
  },
  async saveLocation({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'saveLocation', () => http.post('firm/saveFirm', data))
    return r.data
  },
  async updateLocation({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'updateLocation', () => http.post('firm/updateFirmSettings', data))
    return r.data
  },
  async removeLocation({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'removeLocation', () => http.post('firm/removeFirm', data))
    return r.data
  },
  async searchLocations({ commit, dispatch }, search) {
    let _firms = []
    if (search !== undefined && search !== null) {
      if (search.searchterm !== '') {
        let notIncludeFirm = 0
        if (search.notIncludeFirm) {
          notIncludeFirm = search.notIncludeFirm
        }
        let url = ''
        url = `firm/firmSearch/?firm=${search.firm}&searchterm=${search.searchterm}&notIncludeFirm=${notIncludeFirm}&type=${
          search.type ? search.type : null
        }`
        let data = await http.get(url)
        if (data !== undefined && data !== null) {
          if (data.data !== undefined && data.data !== null) {
            console.log('Got Searched Locations', data.data)
            for (let item of data.data) {
              let firm = {
                firm: item.firm,
                name: item.firmName,
                cccId: item.cccId,
                type: item.firmType
              }
              _firms.push(firm)
            }
          }
        }
        commit(types.SET_LOCATIONS_FOUND, _firms)
      }
    }
    return _firms
  },
  async getPreference({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'getPreference', () =>
      http.get('firm/firmPreference', {
        params: data
      })
    )
    return r.data
  },
  async getPreferences({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'getPreferences', () =>
      http.get('firm/firmPreference', {
        params: data
      })
    )
    commit(types.SET_PREFERENCES, r.data)
    return r.data
  },
  async savePreferences({ commit, state }) {
    state.preferences.forEach(element => {
      if (element.changed) {
        let data = {
          firm: element.firm,
          firmPreferenceName: element.name,
          preference: element.value,
          firmPreferenceCategory: element.type,
          isInactive: element.isInactive ? 1 : 0
        }
        http.post('firm/saveFirmPreference', data)
      }
    })
    commit(types.RESET_PREFERENCE_CHANGE)
  },
  async updateFirmSettings({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'updateFirmSettings', () => http.post('firm/updateFirmSettings', data))
    return r.data
  },
  resetEmailTemplate({ commit }, data) {
    commit(types.RESET_EMAIL_TEMPLATE, data)
  },
  async getEmailTemplate({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'getEmailTemplate', () =>
      http.get('admin/getEmailTemplate', {
        params: data
      })
    )
    commit(types.SET_EMAIL_TEMPLATE, r.data)
    return r.data
  },
  updateEmailTemplate({ commit }, data) {
    commit(types.UPDATE_EMAIL_TEMPLATE, data)
  },
  async saveEmailTemplate({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'saveEmailTemplate', () => http.post('admin/saveEmailTemplate', data))
    return r.data
  },
  async deleteEmailTemplate({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'deleteEmailTemplate', () => http.post(`admin/deleteEmailTemplate?emailTemplate=${id}`))
    return r.data
  },
  async getDispatchedTechs({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'getDispatchedTechs', () =>
      http.get('user/dispatchedTechs', {
        params: data
      })
    )
    commit(types.SET_DISPATCHED_TECHS, r.data)
    return r.data
  },
  async moveLocation({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'moveLocation', () => http.post('firm/moveLocation', data))
    return r.data
  },
  setShowAll({ commit }, data) {
    commit(types.SET_SHOW_ALL_SHOPS, data)
  },
  async searchInsurance({ commit, dispatch }, search) {
    let _firms = []
    if (search !== undefined && search !== null) {
      if (search.searchterm !== '') {
        let url = ''
        url = `firm/searchForOptInPrograms/?firm=${search.firm}&search=${search.searchterm}`
        let data = await http.get(url)
        if (data !== undefined && data !== null) {
          if (data.data !== undefined && data.data !== null) {
            for (let item of data.data) {
              let firm = {
                firm: item.firm,
                name: item.firmName,
                license: item.license
              }
              _firms.push(firm)
            }
          }
        }
        commit(types.SET_INSURANCE_FOUND, _firms)
      }
    }
    return _firms
  },
  async getInsurance({ commit, dispatch }, firm) {
    const r = await startLoading(dispatch, 'getInsurance', () => http.get(`firm/optInPrograms?firm=${firm}`))
    console.log('Got Insurance', r.data)
    if (r.data === undefined || r.data === null) {
      r.data = []
    } else if (r.data === '') {
      r.data = []
    }
    commit(types.SET_INSURANCE, r.data)
    return r.data
  },
  async saveInsurance({ commit, state }) {
    http.post('firm/saveOptInPrograms', state.insurance)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/locations/actions.js